module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-10-1d5be7e36089d9b6eefcc16e14350636.png";